import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function LoginPage() {
  const { t } = useTranslation("auth");

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="mx-auto max-w-sm space-y-6 text-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Content OS</h1>
          <p className="mt-2 text-muted-foreground">
            {t("login.tagline")}
          </p>
        </div>
        <Button
          size="lg"
          className="w-full"
          onClick={() => {
            window.location.href = `/api/auth/google`;
          }}
        >
          {t("login.signInWithGoogle")}
        </Button>
      </div>
    </div>
  );
}
